import { baseAppApi } from '@/core/network/baseAppApi';
import { COMMON_HEADERS } from '@/core/network/network.constants';
import { EmployeeType } from '@/common/common.types';
import { getBoardId } from '@/core/web-storage/webStorage.utils';
import { getFirstErrorOrDefault, getRangeFromHeader } from '@/core/network/network.utils';
import tokens from '@/review-payroll/tokens.json';

export interface Period {
  ataFees: number;
  contributions: number;
  employees: number;
  psp: number;
}

export interface GetReviewPayrollSuccessResponse {
  uploadId: string;
  boardNumber: string;
  totalSalaryPaid: string;
  totalContributions: string;
  totalATAFees: string;
  periods: { [key: string]: Period };
  employees: EmployeeType[];
}
export interface ReviewPayrollSuccessResponse extends GetReviewPayrollSuccessResponse {
  totalEmployees: number;
}

export interface ReviewPayrollRequest {
  page?: number;
  uploadId: string;
}

export const RECORDS_PER_PAGE = 100;

const reviewPayrollApi = baseAppApi.injectEndpoints({
  endpoints: (build) => ({
    getParsedCotents: build.query<ReviewPayrollSuccessResponse, ReviewPayrollRequest>({
      query({ page = 0, uploadId }) {
        const boardId = getBoardId();
        return {
          url: `/v1/employers/${boardId}/uploads/${uploadId}`,
          headers: COMMON_HEADERS,
          params: { pageNum: page + 1, pageSize: RECORDS_PER_PAGE },
        };
      },
      transformResponse(response: GetReviewPayrollSuccessResponse, meta) {
        const total = getRangeFromHeader(meta)[2];
        if (!total || total < 0) {
          throw new Error('Invalid Content-Range value');
        }

        return {
          ...response,
          totalEmployees: total,
        };
      },
      transformErrorResponse(response) {
        return getFirstErrorOrDefault(response, tokens['UPLOAD_ERROR']);
      },
    }),
    discardUpload: build.mutation<unknown, { uploadId: string }>({
      query({ uploadId }) {
        const boardId = getBoardId();
        return {
          url: `/v1/employers/${boardId}/uploads/${uploadId}`,
          method: 'DELETE',
        };
      },
      transformErrorResponse(response) {
        return getFirstErrorOrDefault(response, tokens['DISCARDING_ERROR']);
      },
    }),
  }),
  overrideExisting: false,
});

export { reviewPayrollApi };
